import { render } from "./SectionSlider.vue?vue&type=template&id=749d97d9"
import script from "./SectionSlider.vue?vue&type=script&lang=js"
export * from "./SectionSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__